import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';

const sellerInformPage: FlowPage = {
  slug: () => 'seller-inform',
  isEnabled: () => true,
  autoAdvance: () => false,
  nextText: () => 'Next',
  questions: (): Array<FlowQuestion> => [
    {
      key: 'seller-inform',
      type: 'element',
      component: 'exclusives_inform',
    },
  ],
};

export default sellerInformPage;
